import { SwitchProps } from 'antd/lib/switch';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { ReactNode } from 'react';

import Checkbox from 'components/checkbox';
import { StyledSwitch, SwitchLabel, SwitchContainer } from './styles';

export interface ISwitchProps extends SwitchProps {
  label?: ReactNode;
  variant?: 'toggle' | 'checkbox';
}

const Switch = ({
  label,
  style,
  className,
  variant = 'toggle',
  checked,
  defaultChecked,
  onChange,
  disabled,
  loading,
  ...props
}: ISwitchProps): JSX.Element => {
  const renderLabel = (value: ReactNode) => {
    if (typeof value !== 'string') return value;
    if (!value.includes('<')) return value;
    return <span dangerouslySetInnerHTML={{ __html: value }} />;
  };

  if (variant === 'checkbox') {
    const {
      checkedChildren: _checkedChildren,
      unCheckedChildren: _unCheckedChildren,
      size: _size,
      onClick: _onClick,
      ...checkboxProps
    } = props;
    const isControlled = typeof checked === 'boolean';
    const handleCheckboxChange = (event: CheckboxChangeEvent) => {
      onChange?.(event.target.checked, event.nativeEvent);
    };

    return (
      <Checkbox
        {...checkboxProps}
        className={className}
        style={style}
        label={renderLabel(label)}
        controlled={isControlled}
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled || loading}
        onChange={handleCheckboxChange}
      />
    );
  }

  return (
    <SwitchContainer className={className} style={style}>
      {label && <SwitchLabel>{renderLabel(label)}</SwitchLabel>}
      <StyledSwitch
        className={className}
        checked={checked}
        defaultChecked={defaultChecked}
        onChange={onChange}
        disabled={disabled}
        loading={loading}
        {...props}
      />
    </SwitchContainer>
  );
};

export default Switch;
